import { Badge, DEFAULT_THEME, Tooltip, createTheme } from "@mantine/core";
import { generateColors } from "@mantine/colors-generator";
import { StringMap } from "./utilities/types";

const brandGreens = generateColors("#6fd046");
const brandMidnights = [
	"#e5e8f1", // 0
	"#ccd1e4", // 1
	"#99a5cb", // 2
	"#6678aa", // 3
	"#455275", // 4
	"#262e44", // 5
	"#1e2538", // 6
	"#171d2d", // 7
	"#121725", // 8
	"#0a0e18", // 9
] as const;
const brandGrays = [
	"#e1e2e6", // 0
	"#c4c6ce", // 1
	"#888e9d", // 2
	"#575b66", // 3
	"#4a4e57", // 4
	"#3f424a", // 5
	"#32353c", // 6
	"#282a30", // 7
	"#1c1d22", // 8
	"#121317", // 9
] as const;

export function createAIChatTheme(themeConf: StringMap) {
	const themeOverride = {
		primaryColor: "primaryColor",
		colors: {
			primaryColor: brandGreens,
			dark: brandGrays,
		},
		defaultRadius: 0,
		components: {
			Badge: Badge.extend({
				styles: {
					root: { display: "inline-flex" },
				},
			}), // Badge
			Tooltip: Tooltip.extend({
				defaultProps: {
					openDelay: 250,
					closeDelay: 500,
					withArrow: true,
					arrowSize: 6,
					multiline: true,
					events: {
						hover: true,
						focus: true,
						touch: false,
					},
					transitionProps: {
						transition: "fade",
						duration: 200,
					},
				},
			}), // Tooltip
		},
	};

	if (themeConf) {
		if ("primaryColor" in themeConf) {
			themeOverride.colors.primaryColor = generateColors(themeConf.primaryColor);
			themeOverride.colors.dark = DEFAULT_THEME.colors.dark as typeof themeOverride.colors.dark;
		}
		if ("defaultRadius" in themeConf) {
			themeOverride.defaultRadius = Number(themeConf.defaultRadius);
		}
	} // if themeConf

	return createTheme(themeOverride);
}
